import { render, staticRenderFns } from "./GpuList.vue?vue&type=template&id=9bbb42ca&"
import script from "./GpuList.vue?vue&type=script&lang=js&"
export * from "./GpuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports